<template>
  <!-- 
    Лівий блок картки тестування
  -->

  <div class="card card-info">
    <!-- Id, назва, дата створення тікету -->
    <div class="card-body text-center">
      <div class="d-flex align-items-center">
        <div class="flex-grow-1 ms-3">
          <h3 class="card-title">
            #{{ form.ticketId }} - {{ form.ticketName }}
          </h3>
          <p class="card-text">
            <span class="fw-medium"
              >{{ $t("createDate") }} : {{ form.createDatetime }}</span
            >
          </p>
        </div>
      </div>
    </div>

    <!-- Дії з інформацією по тікету (копіювати / експорт в .md) -->
    <div class="card-footer">
      <div class="d-flex align-items-center justify-content-center gap-3">
        <!-- Копіювати id та назву тікету -->
        <a
          class="link-light copy"
          @click="copy('Тікет #' + form.ticketId + ' - ' + form.ticketName)"
        >
          {{ $t("toCopy") }}
          <i class="bx bx-copy align-middle lh-1"></i>
        </a>

        <!--
          Експорт тікету в .md файл
          - завантажує повну інформацію по тікету у форматі Markdown (зручно для Claude Code)
          - відображається лише для співробітників з посадою "Розробник" і вище
        -->
        <a
          class="link-light copy"
          :title="$t('exportToMd')"
          @click="exportToMd()"
        >
          {{ $t("exportToMd") }}
          <img
            :src="require('@/assets/images/file-md.svg')"
            alt=".md"
            width="13"
            height="13"
            class="align-middle"
          >
        </a>
      </div>
    </div>

    <!-- Копіювати пряме посилання на тікет -->
    <div class="card-footer copy" @click="copyLink">
      <div class="text-center">
        <a class="link-light">
          {{ $t("copyLink") }}
          <i class="bx bx-link align-middle lh-1"></i>
        </a>
      </div>
    </div>
  </div>

  <!-- Тайм-трекінг -->
  <TimeTracking
    v-if="form.status === 'jobs'"
    :workers="this.form.inJobWorkers"
  />

  <div class="d-flex gap-2 mb-3">
    <!-- Кнопка допомогти (Повідомлення надсилається в групу з ПМ-ом) -->
    <button
      type="button"
      class="btn btn-outline-danger waves-effect waves-light w-100"
      @click="showHelpBox = true"
    >
      {{ $t("admin_help") }}
    </button>

    <!-- Кнопка Протестуйте (Повідомлення надсилається в групу з Тестувальником) -->
    <button
      type="button"
      class="btn btn-outline-info waves-effect waves-light w-100"
      @click="showTestingBox = true"
    >
      {{ $t("TestingTicket") }}
    </button>
  </div>

  <!-- Про тікет (деталі) -->
  <b-card>
    <div class="card-header align-items-center d-flex">
      <h4 class="card-title mb-0 flex-grow-1">{{ $t("aboutTicket") }}</h4>

      <!-- 
        Додаткові дії з тікетом
        - йде перевірка на права доступу 2000 (режим бога) 
        - або якщо той хто переглядає є автором тікету
        - або є розробником в цьому тікеті ( || this.form.inJobWorkers.filter((item) => item.workerId == this.user.userid).length > 0  ) - поки прибрав
      -->
      <!-- <div
        class="flex-shrink-0"
        v-if="
          form.createWorkerId == user.userid || 
          this.perms[2000]
        "
      > Олегу К потрібно-->
      <div class="flex-shrink-0">
        <div class="dropdown card-header-dropdown">
          <a
            class="text-reset dropdown-btn"
            href="#"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span class="text-muted">
              <i class="ri-settings-4-line align-middle me-1 fs-15"></i>
              {{ $t("action") }}
            </span>
          </a>
          <div class="dropdown-menu dropdown-menu-end">
            <!-- Кнопка змінити пріоритет -->
            <button
              class="dropdown-item"
              @click="
                this.newType = this.form.type;
                showTypeBox = true;
              "
            >
              {{ $t("ChangeTicketType") }}
            </button>

            <!-- Кнопка змінити пріоритет -->
            <button class="dropdown-item" @click="showPriorityBox = true">
              {{ $t("ChangePriority") }}
            </button>

            <!-- Кнопка змінити середовище проблеми -->
            <button class="dropdown-item" @click="showProblemBox = true">
              {{ $t("ChangeEnvProblem") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="table-responsive table-card">
        <table class="table table-borderless align-middle mb-0">
          <tbody>
            <!-- Id тікету -->
            <tr>
              <td class="fw-medium">{{ $t("ticket") }}</td>
              <td>#{{ form.ticketId }}</td>
            </tr>

            <!-- Тип тікету -->
            <tr>
              <td class="fw-medium">{{ $t("ticket_type") }}</td>
              <td class="hstack text-wrap gap-1">
                {{ this.mutateticket(form.type) }}
              </td>
            </tr>

            <!-- Середовище проблеми -->
            <tr v-if="form.problemEnvironment != null">
              <td class="fw-medium">{{ $t("problem_area") }}</td>
              <td class="hstack text-wrap gap-1">
                {{ mutateProblemEnv(form.problemEnvironment) }}
              </td>
            </tr>

            <!-- Статус рішення до тікету -->
            <tr v-if="form.decidedStatus">
              <td class="fw-medium">{{ $t("decidedStatus") }}:</td>
              <td>
                <span
                  :class="
                    'badge ' +
                    this.mutateDecidedStatus(form.decidedStatus).color
                  "
                  >{{ this.mutateDecidedStatus(form.decidedStatus).name }}</span
                >
              </td>
            </tr>

            <!-- Статус тікету -->
            <tr>
              <td class="fw-medium">{{ $t("Status") }}:</td>
              <td>
                <span
                  :class="
                    'badge ' + this.mutatestatus(form.status, this.form).color
                  "
                  >{{ this.mutatestatus(form.status, this.form).name }}</span
                >
              </td>
            </tr>

            <!-- Пріоритет -->
            <tr>
              <td class="fw-medium">{{ $t("priority") }}</td>
              <td>
                <span
                  :class="'badge ' + this.mutatepriority(form.priority).color"
                  >{{ this.mutatepriority(form.priority).name }}</span
                >
              </td>
            </tr>

            <!-- Автор тікету -->
            <tr>
              <td class="fw-medium">{{ $t("added") }}</td>
              <td>{{ nameWorker(form.createWorkerId) }}</td>
            </tr>

            <!-- Дата створення -->
            <tr>
              <td class="fw-medium">{{ $t("createDate") }}</td>
              <td>{{ form.createDatetime }}</td>
            </tr>

            <!-- Дата взяття в роботу -->
            <tr class="border-top" v-if="form.injobDatetime">
              <td class="fw-medium">{{ $t("DateofEmployment") }}</td>
              <td>{{ form.injobDatetime }}</td>
            </tr>

            <!--
              Орієнтовна дата виконання
              - вказується розробником при взятті тікета в роботу (необов'язково)
              - редагувати може лише виконавець тікета (inJobWorkers)
            -->
            <tr v-if="form.estimatedDate || canEditEstimatedDate">
              <td class="fw-medium">{{ $t("estimatedDate") }}</td>
              <td>
                {{ form.estimatedDate ? String(form.estimatedDate).split(" ")[0] : "-" }}
                <a
                  v-if="canEditEstimatedDate"
                  class="copy ms-1"
                  @click="showEstimatedDateBox = true"
                >
                  <i class="ri-pencil-fill align-bottom"></i>
                </a>
              </td>
            </tr>

            <!-- Дедлайн (дата релізу) - показуємо, якщо в тікеті вказано дедлайн -->
            <tr v-if="form.deadlineId && getDeadline(form) != '-'">
              <td class="fw-medium">{{ $t("dateRelease") }}</td>
              <td>{{ getDeadline(form) }}</td>
            </tr>

            <!-- Мітки -->
            <tr class="border-top">
              <td class="fw-medium">{{ $t("labels") }}</td>
              <td>
                <button
                  @click="showTagBox = true"
                  type="button"
                  class="btn btn-soft-info waves-effect waves-light"
                >
                  додати
                </button>
              </td>
            </tr>

            <!-- Список міток -->
            <div>
              <span
                class="fs-14 fw-semibold"
                style="
                  word-break: break-all;
                  width: 100%;
                  display: block;
                  margin-right: 6px;
                  margin-bottom: 5px;
                  padding: 7px;
                  border-radius: 5px;
                "
                v-for="item in form.hashtags"
                :key="item"
              >
                {{ item.hashtagName }}
              </span>
            </div>
          </tbody>
        </table>
      </div>
    </div>
  </b-card>

  <!-- номери клієнтів -->
  <numbers
    v-if="form.userPhones"
    :obj="form"
    @openclient="openclient"
    @updateCard="updateCard"
    :showComp="false"
  />
  <!-- номери клієнтів -->

  <!-- нові номери клієнти -->
  <clientNumbers
    v-if="form.userPhones"
    :obj="form"
    @openclient="openclient"
    @updateCard="updateCard"
  />
  <!-- нові номери клієнти -->

  <!-- команды/ пользователи -->
  <teams @addteam="addteam" :obj="form" />
  <!-- команды/ пользователи -->

  <!-- Тестування -->
  <testingBlock v-if="perms[666]" />

  <!-- Модальне вікно на зміну типу тікету -->
  <!--
    Модалка редагування орієнтовної дати виконання
      @confirm - зберегти нову дату (або null, якщо очистили)
  -->
  <modalEstimatedDate
    v-if="showEstimatedDateBox === true"
    :obj="this.form"
    mode="edit"
    @close="showEstimatedDateBox = false"
    @confirm="saveEstimatedDate"
  />

  <dialogBox v-if="showTypeBox" @close="showTypeBox = false">
    <template v-slot:title>{{ $t("ChangeTicketType") }}</template>
    <template v-slot:body>
      <div class="mt-1 text-center">
        <h3 class="mb-3">
          <b>{{ $t("selectNewPr") }}</b>
        </h3>
        <Multiselect
          v-model="newType"
          :close-on-select="true"
          :searchable="true"
          :create-option="false"
          :options="this.listType"
          :placeholder="$t('priority')"
        />
      </div>
    </template>
    <template v-slot:footer-bottom>
      <div class="hstack gap-2 mt-3 justify-content-center remove">
        <button class="btn btn-danger" @click="$emit('close')">
          {{ $t("cancel") }}
        </button>
        <button class="btn btn-success" @click="changeTypeTicket">
          {{ $t("Edit") }}
        </button>
      </div>
    </template>
  </dialogBox>

  <!-- Модальне вікно на зміну пріоритету -->
  <dialogBox v-if="showPriorityBox" @close="showPriorityBox = false">
    <template v-slot:title>{{ $t("ChangePriority") }}</template>
    <template v-slot:body>
      <div class="mt-1 text-center">
        <h3 class="mb-3">
          <b>{{ $t("selectNewPr") }}</b>
        </h3>
        <Multiselect
          v-model="newForm.priority"
          :close-on-select="true"
          :searchable="true"
          :create-option="false"
          :options="this.listPriority"
          :placeholder="$t('priority')"
        />
      </div>
    </template>
    <template v-slot:footer-bottom>
      <div class="hstack gap-2 mt-3 justify-content-center remove">
        <button class="btn btn-danger" @click="$emit('close')">
          {{ $t("cancel") }}
        </button>
        <button class="btn btn-success" @click="changePriority">
          {{ $t("Edit") }}
        </button>
      </div>
    </template>
  </dialogBox>

  <!-- Модальне вікно на додавання мітки -->
  <modalTag
    v-if="showTagBox"
    @close="showTagBox = false"
    :typeTags="'tags'"
    :checkedTags="form.hashtags"
    :ticketId="form.ticketId"
    @selectedTags="selectedTags"
    @updateCard="this.$emit('updateCard')"
  />

  <!-- Модальне вікно на зміну середовища проблеми -->
  <changeProblem
    v-if="showProblemBox"
    @close="showProblemBox = false"
    :objCard="form"
  />

  <!-- Модальне вікно на запит допомоги -->
  <helpBox v-if="showHelpBox" @close="showHelpBox = false" :objCard="form" />

  <!-- Модальне вікно на запит протестувати тікет -->
  <testingBox
    v-if="showTestingBox"
    @close="showTestingBox = false"
    :objCard="form"
  />
</template>

<script>
import dialogBox from "@/components/modal/dialog";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import reportsbox from "./reports/reports";
import teams from "./teamticket";
import filexbox from "./files/filesblock";
import numbers from "./clientnumber";
import clientNumbers from "./clientnumberNew.vue";
import devices from "./devices";
import TimeTracking from "@/components/timeTracking";
import changeProblem from "../actions/changeProblem.vue";
import modalEstimatedDate from "../actions/estimatedDate.vue"; // модалка орієнтовної дати виконання
// import modalTag from '@/components/tags/add'
import modalTag from "@/components/tags/list";
import helpBox from "./helpBox";
import testingBox from "./testingBox.vue";
import testingBlock from "./testing/index";
import { nameWorker, tgAccWorker } from "@/usabilityScripts/getNameWorker";
import { Tickets } from "@/API";
import { storeS } from "@/store";
import {
  mutateTypeTicket,
  mutateStatusTicket,
  mutateDecidedStatusTicket,
  mutatePriorityTicket,
  mutateProblemEnv,
  nameTag,
} from "@/usabilityScripts/globalMutate.js";
import { sendTelegramChangePTicket } from "@/usabilityScripts/logsTelegram.js";
import { copy } from "@/usabilityScripts/copy.js";
import { exportTicketToMd } from "@/usabilityScripts/exportTicket";

let apiServe = new Tickets();

export default {
  props: ["obj", "viewRepBox"],
  components: {
    reportsbox,
    teams,
    filexbox,
    numbers,
    clientNumbers,
    devices,
    TimeTracking,
    dialogBox,
    Multiselect,
    changeProblem,
    modalEstimatedDate,
    modalTag,
    helpBox,
    testingBlock,
    testingBox,
  },
  data() {
    return {
      newType: "",
      listType: [
        {
          label: this.$t("problem_to_develop"),
          value: "problem",
        },
        {
          label: this.$t("wish_to_develop"),
          value: "wishes",
        },
      ],
      showTypeBox: false,
      showEstimatedDateBox: false, // прапорець модалки редагування орієнтовної дати
      showTagBox: false,
      showProblemBox: false,
      showHelpBox: false,
      showTestingBox: false,
      form: "",
      newForm: {
        priority: "",
      },
      showPriorityBox: false,
      listPriority: [
        {
          label: this.$t("Critical"),
          value: "3",
        },
        {
          label: this.$t("priorityHigh"),
          value: "2",
        },
        {
          label: this.$t("priorityMedium"),
          value: "1",
        },
        {
          label: this.$t("priorityLow"),
          value: "0",
        },
      ],
    };
  },
  created() {
    this.getdata();
    // this.calcdate()
  },
  methods: {
    changeTypeTicket() {
      apiServe
        .changeTicketType(this.form.ticketId, { type: this.newType })
        .then((result) => {
          if (result.status == "done") {
            this.$toast.success(this.$t("TypeTicketChanged"));
            this.$emit("updateCard");
          } else {
            this.$toast.error(this.$t("error"));
          }
        });
    },
    /**
     * Збереження орієнтовної дати виконання тікета
     * @param {String|null} estimatedDate - дата у форматі Y-m-d, або null щоб очистити
     */
    saveEstimatedDate(estimatedDate) {
      this.showEstimatedDateBox = false;

      apiServe
        .editEstimatedDate(this.form.ticketId, { estimatedDate: estimatedDate })
        .then((result) => {
          if (result.status == "done") {
            this.$toast.success(this.$t("alertChanged"));
            this.$emit("updateCard");
          } else {
            this.$toast.error(this.$t("error"));
          }
        });
    },
    getdata() {
      console.log(this.obj);
      this.form = this.obj;
      this.newForm.priority = this.form.priority;
    },
    selectedTags(ids) {
      this.form.tags = ids;
      this.form.comment = this.form.createComment;
      apiServe.editTicket(this.form.ticketId, this.form).then((result) => {
        if (result.status == "done") {
          this.$toast.success("done");
        } else {
          this.$toast.error($t("error"));
        }
      });
      //додавання тегів до тикету
    },
    openreport(e) {
      this.$emit("openreport", e);
    },
    showteams() {
      this.$emit("showteams");
    },
    openclient(e) {
      this.$emit("openclient", e);
    },
    opendevice(e) {
      this.$emit("opendevice", e);
    },
    changePriority() {
      // Змінити пріоритет тікету

      apiServe
        .changePriority(this.form.ticketId, this.newForm)
        .then((result) => {
          if (result.status == "done") {
            this.$toast.success(this.$t("PriorityChangSucc"));
            this.eventBus.emit("updateTicket", true);
            this.showPriorityBox = false;

            console.log("new", this.newForm);

            // Надсилаємо оповіщення ще в одну тг, щоб не пропустити
            if (this.newForm.priority == "2" || this.newForm.priority == "3") {
              var ticketdId = result.data.ticketId;
              var type = this.mutateticket(result.data.type);
              var problemEnvironment = this.mutateProblemEnv(
                result.data.problemEnvironment
              );
              var createWorkerId = this.nameWorker(this.user.userid);
              var tgAccCreateWorker = this.tgWorker(this.user.userid).tgNick;
              var tgAccAuthorTicket = this.tgWorker(
                result.data.createWorkerId
              ).tgNick;
              var ticketName = result.data.ticketName;
              var createComment = result.data.createComment;
              var oldPriority = this.mutatepriority(this.form.priority).name;
              var newPriority = this.mutatepriority(result.data.priority).name;

              // Викликаємо функцію для відправки повідомлення в телеграм
              sendTelegramChangePTicket(
                ticketdId,
                type,
                problemEnvironment,
                createWorkerId,
                ticketName,
                createComment,
                oldPriority,
                newPriority,
                tgAccCreateWorker,
                tgAccAuthorTicket
              )
                .then((response) =>
                  console.log("Telegram API response:", response.data)
                )
                .catch((error) => console.error("Telegram API error:", error));
            }
          } else {
            this.$toast.error(this.$t("error"));
          }
        });
    },
    copy(item) {
      // копіювання
      if (copy(item) == true) {
        this.$toast.success(this.$t("Copied"));
      } else {
        this.$toast.error(`Fucking mistake, contact Borys`);
      }
      return;
    },
    copyLink() {
      // копіювання прямого посилання на тікет (?ticket=<id>)
      // використовуємо поточний шлях сторінки (тікети / архів), щоб посилання вело туди,
      // звідки відкрито картку, а не завжди на /newtickets/all
      const link = `${window.location.origin}${window.location.pathname}?ticket=${this.form.ticketId}`;
      this.copy(link);
    },
    async exportToMd() {
      // Експорт тікету в .zip архів (.md файл + чат + зображення з опису)
      try {
        // підвантажуємо переписку чату для окремого файлу
        let messages = [];
        try {
          let result = await apiServe.getMessages(this.form.ticketId);
          if (result.status == "done") {
            messages = result.data;
          }
        } catch (e) {
          console.error("[exportToMd] не вдалося завантажити чат:", e);
        }

        // підвантажуємо вкладення тікету (логи та інші матеріали) разом з бінарними даними
        let attachments = [];
        try {
          let filesResult = await apiServe.getFiles(this.form.ticketId);
          if (filesResult.status == "done" && Array.isArray(filesResult.data)) {
            for (let file of filesResult.data) {
              // відео пропускаємо - агент не може його обробити
              if ((file.type || "").startsWith("video/")) {
                continue;
              }
              try {
                let response = await apiServe.getFile(file.fileId, file.type);
                attachments.push({
                  name: file.name,
                  type: file.type,
                  datetime: file.datetime,
                  data: response.data, // ArrayBuffer
                });
              } catch (e) {
                console.error(
                  "[exportToMd] не вдалося завантажити файл:",
                  file.name,
                  e
                );
              }
            }
          }
        } catch (e) {
          console.error("[exportToMd] не вдалося завантажити список файлів:", e);
        }

        await exportTicketToMd(this.form, messages, attachments);
      } catch (error) {
        console.error(error);
        this.$toast.error(this.$t("error"));
      }
    },
    nameWorker(item) {
      return nameWorker(item);
    },
    getDeadline(e) {
      // отримання дати релізу (дедлайну) по deadlineId тікету
      const deadline = this.deadlines.find(
        (el) => el.deadlineId === e.deadlineId
      );

      // залишаємо лише дату, без часу
      return deadline ? deadline.deadlineDate.split(" ")[0] : "-";
    },
    tgWorker(item) {
      // отримання нікнейму співробітника
      return tgAccWorker(item);
    },
    mutateticket(e) {
      return mutateTypeTicket(e);
    },
    mutatestatus(e, form) {
      return mutateStatusTicket(e, this.nameWorker(form.assignedWorkerId));
    },
    mutatepriority(e) {
      return mutatePriorityTicket(e);
    },
    mutateDecidedStatus(e) {
      return mutateDecidedStatusTicket(e);
    },
    mutateProblemEnv(e) {
      const project = this.developmentProjects.find(
        (el) => el.projectKey === e
      );

      if (!project) {
        console.warn(`Проєкт з ключем ${e} не знайдено`);

        return "Проєкт з ключем " + e + " не знайдено"; // або поверніть значення за замовчуванням
      }

      return project.projectName;
    },
    nameTag(e) {
      return nameTag(e);
    },
  },
  mounted() {},
  computed: {
    workers() {
      return storeS.workers;
    },
    user() {
      return storeS.userbase;
    },
    perms() {
      return storeS.perms;
    },
    canEditEstimatedDate() {
      // редагувати орієнтовну дату може той, хто взяв тікет у роботу, або режим бога (2000)
      return (
        this.perms[2000] == true ||
        (Array.isArray(this.form.inJobWorkers) &&
          this.form.inJobWorkers.some((el) => el.workerId == this.user.userid))
      );
    },
    developmentProjects() {
      // Отримання проектів
      return storeS.developmentProjects;
    },
    deadlines() {
      // Отримання списку дедлайнів (релізів), до старту додатку в сторі лежить {}
      return Array.isArray(storeS.dealines) ? storeS.dealines : [];
    },
  },
};
</script>
